import {ICrudLocale} from "../../../i18n/interface";

export const GAME_SESSION_LOCALE_ES: ICrudLocale = {
  GAME_SESSION: {
    FIELD: {
      SESSION: 'Sesión',
      PERFORMANCE: 'Performance',
      RESULT: 'Resultado',
      SESSION_DATE: 'Fecha de la sesión',
      GAME: 'Juego',
      AVG_HR: 'Media HeartRate'
    },
    TEXT: {
      BAD: 'Malo',
      REGULAR: 'Regular',
      GOOD: 'Bueno',
    },

    LABEL: {
      SINGULAR: 'Sesión de juego',
      PLURAL: 'Sesiones de juego',
    },
    LIST: {
      TITLE: 'Listado de sesiones'
    }
  }
}
